import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { isSchoolsReady } from "state/teachers/selectors";

import Gate from "components/Gate";
import LoadingPage from "components/LoadingPage";

const ConnectedPreloader = connect(
  (state, ownProps) => ({
        isOpen: isSchoolsReady(state) && ownProps.isPageReady(state)
      })
)(Gate);

ConnectedPreloader.defaultProps = {
  isPageReady: (state) => true,
  placeholder: <LoadingPage />
}

ConnectedPreloader.PropTypes = {
  isPageReady: PropTypes.func,
  placeholder: PropTypes.node
}

export default ConnectedPreloader;



// WEBPACK FOOTER //
// ./src/components/teachers/Preloader.js